import React, { useState, useEffect } from "react";
import "./style.css";
import API from "../../utils/API";
import Table from "react-bootstrap/Table";
import cogoToast from "@successtar/cogo-toast";

function CreateVehicle({ clientID, autoData, parentPolicy }) {
  const [formData, setFormData] = useState({
    createActivated: false,
    VIN: "",
    year: "",
    make: "",
    model: "",
    compDed: "",
    collDed: "",
    glassDed: "",
    IDCard: "",
    parentPolicy: "",
    activeOnPolicy: true,
    policies: undefined,
    docName: "",
    document: "",
    url: "",
    uploaded: undefined
  });

  useEffect(() => {
    setTimeout(() => {
      getPolicies(clientID);
    }, 1000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const getPolicies = (clientID) => {
    API.findClientsAutoPolicies(clientID).then((res) => {
      setFormData((prev) => ({
        ...prev,
        policies: res.data
      }));
    });
  };

  const getBase64 = (file, callBack) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      callBack(reader.result);
    };
    reader.onerror = function (error) {
      console.log("Error: ", error);
      return error;
    };
  };

  const fileSelectedHandler = (event) => {
    event.preventDefault();
    console.log(event.target.files);
    setFormData((prev) => ({
      ...prev,
      docName: event.target.files[0].name
    }));
    if (event.target.files[0]) {
      getBase64(event.target.files[0], (res) => {
        console.log(res);
        setFormData((prev) => ({
          ...prev,
          document: res
        }));
      });
    }
  };

  const handleCarSubmit = (e) => {
    e.preventDefault();
    API.saveVehicle(autoData[0]._id, {
      VIN: formData.VIN,
      year: formData.year,
      make: formData.make,
      model: formData.model,
      compDed: formData.compDed,
      collDed: formData.collDed,
      glassDed: formData.glassDed,
      parentPolicy: formData.parentPolicy,
      activeOnPolicy: formData.activeOnPolicy
    })
      .then((res) => {
        cogoToast.success("You've saved the Vehicle");
        if (formData.document.length > 0) {
          if (formData.docName.length > 0) {
            API.createDocumentForVehicle(res.data._id, {
              docName: formData.docName,
              document: formData.document,
              policyid: res.data._id,
              type: "vehicle"
            })
              .then((_res) => {
                cogoToast.success("Uploaded Vehicle Document!");
              })
              .catch((_err) => console.log(_err));
          } else {
            API.createDocumentForVehicle(res.data._id, {
              docName: `${formData.year + " " + formData.model} Document`,
              document: formData.document,
              policyid: res.data._id,
              type: "vehicle"
            })
              .then((_res) => {
                cogoToast.success("Uploaded Vehicle Document!");
              })
              .catch((_err) => console.log(_err));
          }
        }
      })
      .catch((_err) =>
        alert("WARNING, VEHICLE NOT SAVED. PLEASE TRY AGAIN, IF ERROR PERSISTS CALL 610-299-9918")
      );
  };

  return (
    <div className="col-lg-12">
      <div className="card">
        <div className="card-header">
          Create a Vehicle
          <br />
        </div>
        <div className="card-body">
          <Table responsive>
            <tbody>
              <tr>
                <td>
                  <strong>Info needed</strong>
                </td>
                <td>
                  <strong>Input</strong>
                </td>
              </tr>
              <tr>
                <td>Year: </td>
                <td>
                  <input
                    type="number"
                    onChange={handleInputChange}
                    value={formData.year}
                    name="year"
                  />
                </td>
              </tr>
              <tr>
                <td>Make: </td>
                <td>
                  <input
                    type="text"
                    onChange={handleInputChange}
                    value={formData.make}
                    name="make"
                  />
                </td>
              </tr>
              <tr>
                <td>Model: </td>
                <td>
                  <input
                    type="text"
                    onChange={handleInputChange}
                    value={formData.model}
                    name="model"
                  />
                </td>
              </tr>
              <tr>
                <td>Comprehensive Deductible: </td>
                <td>
                  <input
                    type="number"
                    onChange={handleInputChange}
                    value={formData.compDed}
                    name="compDed"
                  />
                </td>
              </tr>
              <tr>
                <td>Collision Deductible: </td>
                <td>
                  <input
                    type="number"
                    onChange={handleInputChange}
                    value={formData.collDed}
                    name="collDed"
                  />
                </td>
              </tr>
              <tr>
                <td>Glass Deductible: </td>
                <td>
                  <input
                    type="number"
                    onChange={handleInputChange}
                    value={formData.glassDed}
                    name="glassDed"
                  />
                </td>
              </tr>
              <tr>
                <td>IDCard: </td>
                <td>
                  <input style={{ width: "80%" }} type="file" onChange={fileSelectedHandler} />
                </td>
              </tr>
              <tr>
                <td>VIN #: </td>
                <td>
                  <input type="text" onChange={handleInputChange} value={formData.VIN} name="VIN" />
                </td>
              </tr>
              <tr>
                <td>Policy Assignment</td>
                {formData.policies ? (
                  <td>
                    <select
                      id="protegeDropMenu"
                      value={parentPolicy}
                      onChange={handleInputChange}
                      name="parentPolicy"
                      type=""
                    >
                      <option value="">--Select a Policy--</option>
                      {formData.policies.map((policy) => (
                        <option key={policy._id} value={policy._id}>
                          {policy.carrier} #{policy.policyNumber}
                        </option>
                      ))}
                    </select>
                  </td>
                ) : (
                  <td>"No auto policies yet"</td>
                )}
              </tr>
            </tbody>
          </Table>
          <button
            style={{ textAlign: "center" }}
            className="btn btn-success"
            onClick={handleCarSubmit}
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  );
}

export default CreateVehicle;
